import { render, staticRenderFns } from "./VisitedHistory.vue?vue&type=template&id=66f4a4f2&scoped=true&"
import script from "./VisitedHistory.vue?vue&type=script&lang=js&"
export * from "./VisitedHistory.vue?vue&type=script&lang=js&"
import style0 from "./VisitedHistory.vue?vue&type=style&index=0&id=66f4a4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f4a4f2",
  null
  
)

export default component.exports